/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  // ul:    .select-popout__list
  // li:    .select-popout__item
  // li a:  .select-popout__option
  // data-value contains size
  // data-variantsku contains the variant SKU
  const options = document.querySelector('.select-popout__list');
  const optionItems = document.querySelectorAll('.select-popout__item');
  const label = document.querySelector('.breadcrumbs.product__sku');

  optionItems.forEach( option => {
    option.addEventListener('click', (e) => {
      	let sku = e.target.dataset.variantsku;
        label.innerHTML = `SKU: ${sku}`;
    });
  });


  // ShopHelten - Terms & Conditions checkbox at the cart
    /*$("body").on(
        "click",
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
        function () {
            if ($("#agree").is(":checked")) {
                $(this).submit();
            } else {
                alert(
                    "Du skal acceptere handelbetingelserne."
                );
                return false;
            }
        }
    );*/

  $('body').on(
    "click",
    '.radio__button',
    function (evt) {
      /*$('.radio__button').each(function () {
        $( this ).find("label").removeClass("checked");
      })
      $( this ).find("label").addClass("checked"); */

      // Hide all SKU and Barcode/EAN
      $(".product__barcode").hide();
      $(".product__sku").hide();

      // Now show selected variant's SKU and Barcode/EAN
      var sku = $(evt.currentTarget).data("sku");
      $(`.sku-${sku}`).show();
      var barcode = $(evt.currentTarget).data("barcode");
      $(`.barcode-${barcode}`).show();
    }
  );

  $('.selector-wrapper').each( (index, element) => {
    $(element).find('.radio__button').click( (event) => {
      $(element).find('.radio__button').find('label').removeClass('checked');
      $(event.currentTarget).find('label').addClass("checked");
    })
  });


  /* Adds Flickity to the products on the collection-page only */
  const initShopheltenSliders = () => {
    if (!document.body.classList.contains('template-collection')) {
      return;
    }
    const sliders = document.querySelectorAll('.js-shophelten-boost-slider');

    sliders.forEach(slider => {
      if (!slider.classList.contains('flickity-enabled')) {
        const flkty = new Flickity(slider, {
          cellAlign: 'left',
          contain: true,
          draggable: true,
          prevNextButtons: true,
          pageDots: false,
          wrapAround: true,
          on: {
            ready: function() {
              // Trigger lazysizes to check for images in the newly created slider
              if (window.lazySizes) {
                window.lazySizes.loader.checkElems();
              }
            },
            change: function() {
              // Trigger lazysizes when slide changes
              if (window.lazySizes) {
                window.lazySizes.loader.checkElems();
              }
            }
          }
        });

        // 1. Prevent the <a> tag from working normally
        const parentLink = slider.closest('a.boost-sd__product-link');
        if (parentLink) {
          parentLink.addEventListener('click', (event) => {
            // If the click came from a flickity button, don't do anything (it should be handled by stopPropagation anyway)
            // But also check if we should prevent default
            if (event.target.closest('.flickity-prev-next-button')) {
               event.preventDefault();
               event.stopPropagation();
               return;
            }
            
            // For other clicks, if they are not "staticClick" handled, we might want to prevent them
            // Actually, the previous implementation prevented ALL clicks and used staticClick for navigation.
            event.preventDefault();
          });
        }

        // 2. Only navigate if it was a real click, not a drag
        flkty.on('staticClick', (event, pointer, cellElement, cellIndex) => {
          if (!parentLink) return;

          // Ensure we are not clicking the buttons
          if (!event.target.closest('.flickity-prev-next-button')) {
            window.location.href = parentLink.getAttribute('href');
          }
        });

        // 3. Keep the button propagation fix
        const buttons = slider.querySelectorAll('.flickity-prev-next-button');
        buttons.forEach(button => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
          });
        });
      }
    });
  };

  // Init sliders
  initShopheltenSliders();

  // Re-init on AJAX (Broadcast theme uses 'theme:grid-item:loaded' or similar, but let's check for standard events)
  document.addEventListener('theme:grid-item:loaded', () => {
    initShopheltenSliders();
  });
  
  // Also common for collection page filters
  document.addEventListener('theme:section:load', () => {
    initShopheltenSliders();
  });

  $(document).on('theme:loading:end', () => {
    initShopheltenSliders();
  });

  // Re-init product image Flickity when switching tabs in Tab collections (sliders are in newly visible tab)
  document.querySelectorAll('.index-tab-collections [data-tabs-holder]').forEach((holder) => {
    holder.addEventListener('click', (e) => {
      if (e.target.closest('.tab-link')) {
        setTimeout(initShopheltenSliders, 150);
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
